'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Questioning(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#4978BB' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size + 8,
      viewBox: '0 0 14 22',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement('path', {
      d: 'M10.294 7.246c-.092 1.318-1.666 2.246-2.867 3.338-1.381 1.255-2.248 1.903-2.248 3.899v.566c0 .998.819 1.806 1.828 1.806 1.01 0 1.828-.808 1.828-1.806v-.566c0-.908.342-1.004.99-1.554.76-.647 4.13-2.743 4.13-5.805 0-.247-.016-.48-.044-.697C13.594 2.931 10.612.182 6.993.182 3.163.182.045 3.262.045 7.046c0 .997.82 1.806 1.828 1.806 1.01 0 1.83-.81 1.83-1.806 0-1.793 1.475-3.251 3.29-3.251 1.814 0 3.29 1.458 3.29 3.25 0 .068.004.135.011.2zM7.007 21.818c-.481 0-.952-.192-1.293-.528a1.81 1.81 0 0 1-.535-1.278c0-.475.195-.94.535-1.277.341-.336.812-.53 1.293-.53.482 0 .952.194 1.293.53.34.336.535.802.535 1.277 0 .476-.194.94-.535 1.278-.34.336-.811.528-1.293.528z',
      fill: color,
      fillRule: 'evenodd'
    })
  );
}

Questioning.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = Questioning;